export const buttonObject = {
  uuid: '',
  text: "按钮文字",
  beforeClick: {
    type: 0, // 0 直接访问使用， 1 填写表单后有效
    form: "", // 表单ID，按钮点击需填写表单
    formtime: "一天" // 表单有效期  无 一天 七天 永久
  },
  afterClick: {
    type: 1, // 点击后类型  0 无跳转，1 跳转页面  2 关联内容 3 发送邮件  4 在线体验
    target: "_self",
    url: "",
    contentType: "data", // data 资料， article 文章， video 视频
    contentId: "",
    contentName: "",
    contentImage: ""
  }
};

export const formObject = {
  form: "", // 表单ID
  formtime: "一天", // 表单有效期  无 一天 七天 永久
  afterClick: {
    type: 1, // 点击后类型  0 无跳转，1 跳转页面  2 关联内容
    url: "",
    contentType: "data", // data 资料， article 文章， video 视频
    contentId: ""
  }
};

// 内容对象 image video article
export const contentObject = {
  contentType: "image",
  contentId: "",
  contentName: "",
  contentDesc: "",
  contentImage: "",
  contentTs: ""
}


// 1活动 2产品 3文章 4方案 5案例 6大客户
export const contentRemoteObject = {
  title: "",
  website_type_id: 0,
  website_type_name: '',
  type_id: 0,
  type_name: '',
  associate_id: [],  // 分类ID
  associate_name: [], // 分类名称
  content_id: [], // 内容ID
  content_name: [], // 内容名称
  website_id: 'mk-autoweb', // 落地页ID
  id: '', // 落地页组件ID
  ajax: {
    url: 'websitecenter/content/netapi/list',
    method: 'GET'
  }
};
